import { Platform, StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  tile: {
    borderColor: Theme.transparent,
    ...Platform.select({
      web: {
        outlineWidth: 0,
      },
    }),
  },
});
